import React, { Component, Fragment } from "react";
import YouTube from "react-youtube";
import Vimeo from "@u-wave/react-vimeo";
import styled from "styled-components";

import Image from "src/components/UI/Image";
import Icon from "src/components/UI/Icon";
import PlayIcon from "src/images/svg/icon-play.svg";

const VideoStyles = styled.div`
  position: relative;
  overflow: hidden;

  .video-image {
    ${(props) => props.theme.mixins.positionCover()};
    z-index: 2;

    > div {
      width: 100% !important;
      height: 100% !important;
    }
  }

  .video-content {
    ${(props) => props.theme.mixins.positionCover()};
    z-index: 3;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > div:not(.video-image):not(.video-content) {
    padding-bottom: ${(props) => props.theme.dimensions.aspectRatio.wide};
    z-index: 1;

    video,
    iframe {
      ${(props) => props.theme.mixins.positionCover()};
    }
  }

  .video-button {
    width: 100%;
    height: 100%;
  }
`;

class Video extends Component {
  constructor(props) {
    super(props);
    this.state = {
      youtubePlayer: null,
      vimeoPlayer: null,
      videoStarted: false,
    };
  }

  youtubeOnReady = (event) => {
    this.setState({
      youtubePlayer: event.target,
    });
  };

  vimeoOnReady = (event) => {
    this.setState({
      vimeoPlayer: event.target,
    });
  };

  onPlayVideo = () => {
    if (this.props.youtubeId) {
      this.state.youtubePlayer.playVideo();
    }
    this.setState({
      videoStarted: true,
    });
  };

  render() {
    const { images, title, youtubeId, vimeoId, youtubeOptions } = this.props;
    const alt = title ? title : "Youtube title";
    return (
      <VideoStyles {...this.props}>
        {!this.state.videoStarted && images && (
          <div className="video-image">
            <Image image={images} alt={alt} />
          </div>
        )}
        {!this.state.videoStarted && images && (
          <div className="video-content">
            <button
              aria-label="Play video"
              className="video-button"
              onClick={this.onPlayVideo}
            >
              <Icon>
                <PlayIcon />
              </Icon>
            </button>
          </div>
        )}
        {youtubeId && (
          <Fragment>
            <YouTube
              videoId={youtubeId}
              opts={youtubeOptions}
              onReady={this.youtubeOnReady}
            />
          </Fragment>
        )}
        {vimeoId && (
          <Fragment>
            <Vimeo video={vimeoId} onReady={this.vimeoOnReady} />
          </Fragment>
        )}
      </VideoStyles>
    );
  }
}
export default Video;
